import { t } from 'i18next';
import { useMemo } from 'react';

import { CSVEntityImportAction } from '~components/CSVImportExport/CSVEntityImportAction';
import { FeatureFlags } from '~constants/featureFlags';
import { createTicketsConfig } from '~hooks/useCSVImportExport/configs/ticketsConfig';
import { useStores } from '~store';

interface TicketImportActionProps {
  onImportComplete: () => void;
}

export const TicketImportAction = ({ onImportComplete }: TicketImportActionProps) => {
  const { userStore } = useStores();
  const userPermissions = userStore.getPermissions();

  const ticketsImportConfig = useMemo(() => createTicketsConfig(), []);

  return (
    <CSVEntityImportAction
      canCreateImportedEntity={userPermissions.canCreateImportedTicket}
      config={ticketsImportConfig}
      entityDisplayName={t('page_headings.tickets')}
      featureFlagKey={FeatureFlags.csvTicketImport}
      onImportComplete={onImportComplete}
    />
  );
};
